import theme from "../../../../theme";
import { SxProps, Theme } from "@mui/material";

export const cardSx:SxProps<Theme> = {
  backgroundColor: theme.palette.common.white,
  p: 2,
  borderBottom: `${theme.spacing(1/8)} solid ${theme.palette.neutral[200]}`,
  position: "relative"
}